module.exports = __webpack_public_path__ + "06_face.cfd63522.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/06_face.png
// module id = s5Gq
// module chunks = 0